export const WorkflowTypes = {
    TimelineCreate: "TimelineCreate",
    TimelineImport: "TimelineImport",
    StructureImport: "StructureImport",
    StyleConverter: "StyleConverter",
    TemplateLibrary: "TemplateLibrary"
};
